import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "antd";
import { BrowserRouter as Router } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { Provider } from 'react-redux'
import store from '@/store/index'
import "normalize.css";
const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById("root"));
// Polyfill for window.crypto.randomUUID
if (!window.crypto.randomUUID) {
	window.crypto.randomUUID = function () {
		return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));
	};
}
// 其他初始化代码
root.render(
	<MsalProvider instance={msalInstance}>
		<Provider store={store}>
			<ConfigProvider
				theme={{
					token: {
						colorPrimary: "#000F52",
					},
				}}
			>
				<Router>
					<App />
				</Router>
			</ConfigProvider>
		</Provider>
	</MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
